<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<template>
  <hr class="text-lightgray my-4" />
  <div class="flex justify-end space-x-2 *:w-[100px]">
    <slot></slot>
  </div>
</template>
